/**
 * Coin display (owner rule 2026-10-20): short form with 2 decimals, always rounded DOWN so a
 * figure never looks higher than the real amount: 1175750 → "1.17M", 144400 → "144.40K", 999 → "999".
 */
// Whole-number math (abs / (unit/100)) avoids float slips like 1.15 → "1.14".
const floor2 = (abs, unit) => (Math.floor(abs / (unit / 100)) / 100).toFixed(2);

export const formatCoin = (val) => {
  const n = Number(val);
  if (!Number.isFinite(n)) return "0";
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1_000_000_000) return `${sign}${floor2(abs, 1_000_000_000)}B`;
  if (abs >= 1_000_000) return `${sign}${floor2(abs, 1_000_000)}M`;
  if (abs >= 1_000) return `${sign}${floor2(abs, 1_000)}K`;
  return `${sign}${Math.trunc(abs)}`;
};

/** Same 2-decimal round-down form (kept for the income / history lists). */
export const formatCoinExact = formatCoin;

export default formatCoin;
